export default "src/content/themes/association-wordpress-theme/img/3a3a583d110f49dbdce7ae7b97321d0e.jpg";